import type { FaireProductEntity } from "../../entity_types/product";

export const p_97su7hdac8: FaireProductEntity = {
  token: "p_97su7hdac8",
  type: "product",
  name: 'Minnesota Loon | Woodcut Print Style Poster (11" x 17")',
  brandName: "Northern Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/2368fc34301389dec7455d10bd9725a085c60e80a412ae03dd3460d2f894ff9c.png",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e7a64ed2e8ee5e9b15a6300102a087fa60848060c2ef2ced034ed28234878d1b.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
